<template>
    <div class="report-box">
        <table>
            <thead>
                <tr>
                    <td colspan="12">
                        <span style="margin-left:10px;">{{pulseTxt1}} 壓力範圍: {{pressureRangeTxt}}</span>
                        <span style="margin-left:20px;"><button type="button" class="btn btn-outline-secondary btn-sm" @click="prevPage">上一波</button></span>
                        <span style="margin-left:10px;"><button type="button" class="btn btn-outline-secondary btn-sm" @click="nextPage">下一波</button></span>
                    </td>
                </tr>
            </thead>
            <tr>
                <td colspan="6">
                    <div>
                        <LineChart :chart-data="lineChartData1" />
                    </div>
                </td>
            </tr>
        </table>
        <div class="report-box">
            <table>
                <thead>
                    <tr>
                        <td v-for="txt in lan[0].title1" :key="txt.id">{{ txt }}</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(txtAry, index1) in lan[0].ecg" :key="index1" style="table-layout:fixed">
                        <td v-for="(txt, index2) in txtAry" :key="index2">
                            <span v-if="index2 == 4" :class="{'txtred':test(index1)}">
                            {{ obj.ecgAry[index1] }} {{txt}}
                            </span>
                            <span v-else>{{ txt }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import LineChart from '@/components/chart/chart.vue'
export default {
    props: ["report"],
    components: {
      LineChart
    },
    data() {
        return{
            account: '',
            report_id: '',

            pressure_range: [],

            chartData: [],

            lineChartData1: {
                labels: [],
                datasets: []
            },

            pulseTxt1: '第一分波',
            pressureRangeTxt: '126 ~ 120',
            pageNow: 1,
            pageLength: 0,

            obj: {
                ecgObj: [],
            },

            lan: [{
                title1: [this.$t("txt_49"), this.$t("txt_50"), this.$t("txt_51"), this.$t("txt_52"), this.$t("txt_53"), this.$t("txt_54")],
                ecg: [
                    ['A1', 'AP1', '', this.$t("txt_55"), 'mmHg', '<70mmHg'],
                    ['A2', 'AP2', '', this.$t("txt_56"), 'mmHg', '>0.25AP1'],
                    ['T1', 'TP1', '', this.$t("txt_57"), 'ms', '<150ms'],
                    ['T2', 'TP2', 'Notch', this.$t("txt_58"), 'ms', '<300ms (' + this.$t("txt_59") + ')'],
                    ['T3', 'TP2V', '', this.$t("txt_60"), '%', '<15%'],
                    ['T4', 'TPT', '', this.$t("txt_61"), 'ms', '>600ms，<1034ms'],
                    ['I1', 'IWT', '', this.$t("txt_62"), '', '<200ms'],
                    ['R1', 'RCT', 'TP1/TPT', this.$t("txt_63"), '', '<0.3'],
                    ['I2', 'IWD', 'IWT/TPT', this.$t("txt_64"), '', '<0.2'],
                    ['D1', 'DWA', 'AP2/AP1', this.$t("txt_65"), '', '<0.7'],
                    ['D2', 'DWT', 'TP2/TPT', this.$t("txt_66"), '', '<0.5'],
                    ['D3', 'DT', 'TP2-TP1', this.$t("txt_67"), '', '<2TP1'],
                    ['D4', 'D', this.$t("txt_69"), this.$t("txt_68"), '', '<0.5RR'],
                    ['P1', 'PD', 'D-TP2', this.$t("txt_70"), '', '<100ms'],
                    ['D5', 'DI', 'TPT-TP2', this.$t("txt_71"), '', '>0.5RR'],
                    ['R2', 'RR', '', this.$t("txt_72"), '', '>600ms，<1034ms'],
                    ['R3', 'RRV', '', this.$t("txt_73"), '%', '<10%'],
                    ['S1', 'ST', '', this.$t("txt_74"), '', '>100，<300ms (' + this.$t("txt_59") + ')'],
                    ['T5', 'TPD', 'TP2/DI', this.$t("txt_75"), '', '0.5-0.8'],
                    ['D6', 'DTP', 'DI-TP2/TP2', this.$t("txt_76"), '', '0.5-0.9'],
                    ['S2', 'SR', '', this.$t("txt_77"), '', '<100ms'],
                    ['A3', 'AS', '', this.$t("txt_78"), '', '<200']
                ]
            }],
        }
    },
    created(){
        const report = JSON.parse(sessionStorage.getItem('client_report'));
        this.report_id = report.id;
        this.getReport()
    },
    methods: {
        getReport() {
            // this.isLoading = true
            const api = `${process.env.VUE_APP_APIPATH}/client/report/v3/data`;
            const json = {
                report_id: this.report_id,
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    const ecg = res.data.data.ecg;
                    const pulse = res.data.data.row.pulse_row.split(" ");
                    const pressure = res.data.data.row.pressure_row.split(" ");

                    this.drawPulse(ecg, pulse, pressure);
                }
            })
        },
        drawPulse(ecg, pulse, pressure) {
            // let pulse_n = [];
            let headAry = [];
            let row = [];
            let e1 = [];
            let e2 = [];
            let pre_index1 = ''; 
            let pre_index2 = '';

            //清除空字符串
            pulse.map(function (val, index) {
                // console.log(currentValue, index)
                if (val == '') {
                pulse.splice(index, 1);
                }
            });

            ecg.map((val, index) => {
                if (val._singal_ecg2 == null || val._single_pulse_index == null) {
                row = [];
                e1 = [];
                e2 = [];
                } else {
                row = val._single_pulse_index.split(" ");
                e1 = val._singal_ecg.split(" ");
                e2 = val._singal_ecg2.split(" ");
                }

                headAry.push([parseInt(row[0]), (parseInt(row[0]) + parseInt(row[1]))]);
                pre_index1 = Math.floor(headAry[index][0] / 7);
                pre_index2 = Math.floor(headAry[index][1] / 7);
                this.pressure_range.push(pressure[pre_index1] + ' ~ ' + pressure[pre_index2]);

                this.obj.ecgObj.push([
                e2[0], e2[1], e2[2], e2[3], e2[4],
                e2[5], e2[6], e2[7], e2[8], e2[9],
                e2[10], e2[11], 0, 0, e2[12],
                e1[0], e1[1], e1[3],
                e2[13], e2[14],
                e1[4], e1[2]
                ]);
            })
            this.getDataPulse(0, headAry, pulse);
            this.pageLength = headAry.length;
            this.obj.ecgAry = this.obj.ecgObj[0];
            this.getShowChart(this.chartData[0].headAry[0], this.chartData[0].data);
        },
        getDataPulse(num, headAry, pulse){
            this.chartData[num] ={
                headAry: headAry, //[[0, 20], [20, 28]]
                data: pulse //[23,321,2564,8789]
            }
        },
        getShowChart(head, data){
            let dataPX = [];
            let dataPY = [];
            this.dataPulse = [];
            for( let i=(head[0]-1), length=(head[1]-1); i<=length; i++ ){
                this.dataPulse.push( [i, data[i]] );
            }
            this.dataPulse.forEach((item) => {
                dataPX.push(item[0]);
                dataPY.push(item[1]);
            })
            let result = {
                labels: dataPX,
                datasets: [
                {
                    label: this.pulseTxt1,
                    backgroundColor: "transparent",
                    data: dataPY,
                    borderColor: "rgba(29, 33, 36, .2)",
                    pointBackgroundColor: "rgba(171, 71, 188, 1)",
                    pointRadius: 1,
                }
                ]
            };
            this.lineChartData1 = result;
        },
        prevPage() {
            if( this.pageNow > 1 ){
                this.pageNow --;
            }
            this.num = this.pageNow;
            this.pulseTxt1 = "第" + this.num + "分波";
            this.obj.ecgAry = this.obj.ecgObj[this.num - 1];
            this.pressureRangeTxt = this.pressure_range[this.num - 1]
            this.getShowChart(this.chartData[0].headAry[this.num - 1], this.chartData[0].data)
        },
        nextPage() {
            if(this.pageNow < this.pageLength){
                this.pageNow ++
            }
            this.num = this.pageNow;
            this.pulseTxt1 = "第" + this.num + "分波";
            this.obj.ecgAry = this.obj.ecgObj[this.num - 1];
            this.pressureRangeTxt = this.pressure_range[this.num - 1]
            this.getShowChart(this.chartData[0].headAry[this.num - 1], this.chartData[0].data)
        },
        test(index) {
            if (!this.obj.ecgAry[index]) {
                return false;
            }

            let data = this.obj.ecgAry[index];
            // console.log(data, index);
            switch (index) {
                case 0:
                if (data < 70) return false;
                break;
                case 1:
                if (data > 0.25) return false;
                break;
                case 2:
                if (data < 150) return false;
                break;
                case 3:
                if (data < 300) return false;
                break;
                case 4:
                if (data < 15) return false;
                break;
                case 5:
                if (data > 600 && data < 1034) return false;
                break;
                case 6:
                if (data < 200) return false;
                break;
                case 7:
                if (data < 0.3) return false;
                break;
                case 8:
                if (data < 0.2) return false;
                break;
                case 9:
                if (data < 0.7) return false;
                break;
                case 10:
                if (data < 0.5) return false;
                break;
                case 11:
                if(data) return false;
                break;
                case 12:
                if(data) return false;
                break;
                case 13:
                if (data < 100) return false;
                break;
                case 14:
                if(data) return false;
                break;
                case 15:
                if (data > 600 && data < 1034) return false;
                break;
                case 16:
                if (data < 10) return false;
                break;
                case 17:
                if (data > 100 && data < 300) return false;
                break;
                case 18:
                if (data >= 0.5 && data <= 0.8) return false;
                break;
                case 19:
                if (data >= 0.5 && data <= 0.9) return false;
                break;
                case 20:
                if (data < 100) return false;
                break;
                case 21:
                if (data < 200) return false;
                break;
                default:
                // console.log(index, 'default')
                return false;
            }
            return true;
        },
    }
}
</script>